import React from "react";

const stats = [
  { value: "2026", label: "Est. in Sheboygan" },
  { value: "200+", label: "Vehicles detailed" },
  { value: "5.0★", label: "Average rating" },
  { value: "100%", label: "Satisfaction guarantee" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#070707]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="relative">
          <div className="relative overflow-hidden border border-zinc-900">
            <img
              src="https://images.unsplash.com/photo-1647844850804-7199e36a78c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxjYXIlMjBjZXJhbWljJTIwY29hdGluZyUyMHNoaW5lfGVufDB8fHx8MTc3NzY1OTAyNHww&ixlib=rb-4.1.0&q=85"
              alt="Royston Mobile Detailing rig"
              className="w-full h-[500px] md:h-[640px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-red-500 text-black p-6 max-w-[240px]">
            <div className="font-display text-5xl uppercase leading-none">
              EST.
            </div>
            <div className="mt-2 text-xs tracking-[0.25em] uppercase font-bold">
              Sheboygan · 2026
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-red-500" />
            <span className="text-xs tracking-[0.3em] uppercase text-red-500 font-bold">
              About Royston
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter leading-[0.95]">
            Detailing is a <br />
            <span className="text-zinc-600">discipline.</span>
          </h2>

          <div className="mt-8 space-y-5 text-zinc-400 text-base md:text-lg leading-relaxed">
            <p>
              Royston Mobile Detailing was founded by two gearheads who couldn't
              stand watching beautiful cars be treated carelessly. Freshly
              opened in 2026, we bring the studio to your driveway across
              Sheboygan and the surrounding area — daily drivers to
              seven-figure exotics.
            </p>
            <p>
              We work out of a fully-equipped mobile rig — pH-neutral
              chemistry, microfiber systems, professional polishers, and
              power/water on board. No rotary scratches. No swirl marks. No
              shortcuts.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-px bg-zinc-900 border border-zinc-900">
            {stats.map((s) => (
              <div
                key={s.label}
                data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-[#0a0a0a] p-6 md:p-8"
              >
                <div className="font-display text-4xl md:text-5xl uppercase tracking-tighter text-white">
                  {s.value}
                </div>
                <div className="mt-2 text-xs tracking-[0.2em] uppercase text-zinc-500">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
